import React from 'react';
import "./smile-pages.css";

export default function IsSmilingBetterThanChocolate() {
  return (
    <div className="container-box mt-5 mb-5 smile-page">
      <h1>Is Smiling Better than Chocolate?</h1>
      <p>
        Smiling can <strong>actually be more powerful than chocolate</strong> in some surprising
        ways — especially when it comes to <strong>your brain, mood, and overall well-being.</strong>
      </p>
      <p>Here’s a science-backed comparison:</p>

      <hr />

      <h2>😄 Smiling vs. 🍫 Chocolate</h2>
      <h3>Why Smiling Might Be Better (But You Can Always Enjoy Both!)</h3>

      <hr />
      <h3>1. Smiling Activates the Brain’s Reward System — More Than Chocolate</h3>
      <ul>
        <li>
          Both smiling and eating chocolate activate the <strong>mesolimbic dopamine pathway</strong> —
          the brain’s “feel-good” circuit.
        </li>
        <li>
          A famous British study found that a <strong>single genuine smile</strong> can be as
          stimulating as up to <strong>2,000 bars of chocolate</strong> in terms of brain activity and
          happiness response!
        </li>
      </ul>

      <p><strong>📚 Source:</strong></p>
      <ul>
        <li>
          British Dental Health Foundation (2005): Found that smiling activated the brain more
          than chocolate, shopping, or even receiving cash.
        </li>
        <li>Reported in: <em>The Independent</em> and <em>BBC News</em></li>
      </ul>

      <hr />
      <h3>2. Smiling Has Zero Calories — And No Crash</h3>
      <p>Unlike chocolate, smiling doesn’t lead to:</p>
      <ul>
        <li>A sugar spike followed by a crash</li>
        <li>Cravings or overconsumption</li>
        <li>Negative health effects if overdone (e.g., weight gain, tooth decay)</li>
      </ul>
      <p>
        Smiling provides a <strong>natural mood boost</strong> without the physical downsides.
      </p>

      <hr />
      <h3>3. Smiling Lasts Longer Emotionally</h3>
      <ul>
        <li>
          The emotional effects of smiling tend to be more <strong>sustainable</strong> than those of
          eating chocolate.
        </li>
        <li>
          Chocolate gives a <strong>brief dopamine hit</strong>, but smiling can lead to lasting:
          <ul>
            <li>Social connection</li>
            <li>Mood improvement</li>
            <li>Stress reduction</li>
          </ul>
        </li>
      </ul>

      <p><strong>📚 Source:</strong></p>
      <ul>
        <li>Kraft & Pressman (2012) — smiling reduces stress and heart rate, even when forced.</li>
      </ul>

      <hr />
      <h3>4. Smiling Strengthens Social Bonds — Chocolate May Not</h3>
      <ul>
        <li>
          A smile invites <strong>connection, trust, and warmth</strong> — chocolate may not.
        </li>
        <li>
          People who smile more often are perceived as <strong>more attractive, approachable, and
          confident</strong>, helping to build stronger relationships.
        </li>
      </ul>

      <p><strong>📚 Source:</strong></p>
      <ul>
        <li>Krumhuber et al. (2007) — Duchenne smiles increase trust and positive impressions.</li>
      </ul>

      <hr />
      <h3>5. Smiling Is Free and Always Available</h3>
      <ul>
        <li>You don’t need to go to a store, spend money, or count calories.</li>
        <li>
          You can smile <strong>anytime, anywhere</strong>, and still get many of the same brain benefits
          as you would from eating chocolate.
        </li>
      </ul>

      <hr />
      <h3>🧠 Summary: Smiling vs. Chocolate</h3>

      <table className="summary-table">
        <thead>
          <tr>
            <th>Benefit</th>
            <th>Smiling 😄</th>
            <th>Chocolate 🍫</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>Boosts dopamine</td><td>✅ Yes</td><td>✅ Yes</td></tr>
          <tr><td>Long-lasting mood lift</td><td>✅ More sustainable</td><td>❌ Short-lived</td></tr>
          <tr><td>Social benefits</td><td>✅ Builds connection</td><td>❌ May not</td></tr>
          <tr><td>Health effects</td><td>✅ Lowers stress, heart rate</td><td>❌ High sugar, possible crash</td></tr>
          <tr><td>Calorie impact</td><td>✅ Zero</td><td>❌ High</td></tr>
          <tr><td>Always accessible</td><td>✅ Yes</td><td>❌ Unfortunately, no</td></tr>
        </tbody>
      </table>

      <hr />
      <h3>🔑 Keys to Remember</h3>
      <p>
        <strong>
          Smiling can be even more powerful than chocolate
        </strong>{' '}
        when it comes to improving mood, health, and social connection — and smiling doesn’t
        cost a thing. While chocolate is a treat, <strong>smiling is a superpower</strong> you can use any
        time!
      </p>
    </div>
  );
}
